module.exports = __webpack_public_path__ + "static/media/2. Issue card.ac1fe949.svg";